import type {ReactNode} from 'react';
import {createContext, useContext} from 'react';
import {useResendInvitation} from '~/overview/hooks/useResendInvitation';

interface ResendInvitationContextValue {
  resendInvitation: (params: {eventId: number; id: string; name: string}) => Promise<boolean>;
  isResending: boolean;
  resendingId: string | null;
  resendingGuestName: string | null;
  canResendToGuest: (guestId: string) => boolean;
}

const ResendInvitationContext = createContext<ResendInvitationContextValue | null>(null);

export const ResendInvitationProvider = ({children}: {children: ReactNode}) => {
  const resendState = useResendInvitation();

  return (
    <ResendInvitationContext.Provider value={resendState}>
      {children}
    </ResendInvitationContext.Provider>
  );
};

export const useResendInvitationContext = (): ResendInvitationContextValue => {
  const context = useContext(ResendInvitationContext);
  if (!context) {
    throw new Error('useResendInvitationContext must be used within ResendInvitationProvider');
  }
  return context;
};
